import script from "./DocumentInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentInfo.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentInfo.vue?vue&type=style&index=0&id=7b80981e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b80981e"]])

export default __exports__